import type { Metric } from '@/shared/generated'
import type { DemandDriversData } from '../lib/demand-drivers'

import {
	DateAggregation,
	useAiBIAnalyticQuery,
	useMetricsQuery,
} from '@/entities/bi'

import { MetricType } from '@/shared/generated'

import { buildDriverRows } from '../lib/demand-drivers'
import { getMonthToDatePeriod } from '../lib/period'

const selectAiMetricNames = (data: Metric[]): string[] =>
	data
		.filter((metric) => metric.type === MetricType.AiImportance)
		.map((metric) => metric.name)

export const useDemandDriversQuery = ({
	optimizationGroupId,
	lineId,
	enabled = true,
}: {
	optimizationGroupId: string
	lineId: string
	enabled?: boolean
}): {
	data: DemandDriversData | undefined
	isPending: boolean
	isError: boolean
} => {
	const metricsQuery = useMetricsQuery<string[]>({
		select: selectAiMetricNames,
	})
	const metrics = metricsQuery.data ?? []
	const hasMetrics = metrics.length > 0

	const biEnabled = enabled && !!optimizationGroupId && !!lineId && hasMetrics

	const biQuery = useAiBIAnalyticQuery<DemandDriversData>(
		{
			label: 'MidTermDemandDrivers',
			...getMonthToDatePeriod(),
			skip_dates: true,
			metrics,
			dimensions: [],
			date_aggregation: DateAggregation.DateKey,
			filters: [
				{
					name: 'optimization_group_id',
					operation: 'is',
					value: optimizationGroupId,
				},
				{ name: 'line_id', operation: 'is', value: lineId },
			],
		},
		{
			enabled: biEnabled,
			select: (data) => buildDriverRows(data.meta, data.data),
		}
	)

	const isError = metricsQuery.isError || biQuery.isError
	const isSettled = metricsQuery.isSuccess && (!biEnabled || biQuery.isSuccess)

	return {
		data: biEnabled ? biQuery.data : undefined,
		isPending: !isError && !isSettled,
		isError,
	}
}
